import { useStrictLocalization } from "@faire/web--source/common/localization";
import { route as helpCenterHomeRoute } from "@faire/web-api--source/routes/www/support";

import { BackToButtonContext, BackToDestination } from "./types";

interface BackToCtaContextMap {
  backToCtaContextMap: Partial<Record<BackToDestination, BackToButtonContext>>;
}

export const useBackToCtaContextMap = (): BackToCtaContextMap => {
  const { strictLocalize } = useStrictLocalization();

  const backToCtaContextMap = {
    [BackToDestination.FAIRE]: {
      label: strictLocalize({
        defaultMessage: "Back to Faire.com",
        description: {
          text: "Link to take the user back to Faire.com home page",
        },
      }),
      linkTo: "/",
    },
    [BackToDestination.HELP_CENTER]: {
      label: strictLocalize({
        defaultMessage: "Back to Help Center",
        description: {
          text: "Link to take the user back to the Help Center.",
        },
      }),
      linkTo: helpCenterHomeRoute,
    },
  };

  return { backToCtaContextMap };
};
